import React, {useState, useRef} from 'react'
import Select from 'react-select'
import DictionaryContext from '../context/DictionaryContext'

function DeviceStatusDropdown(props) {

  const errorBorderColor = 'red'
  const normalBorderColor = 'hsl(0, 0%, 80%)'

  const [reactSelectBorderColor, setReactSelectBorderColor] = useState({});
  const refDeviceStatus = useRef();

  // console.log("Dropdown - props", props)

  const onSelect = (e) => {
    // console.log("e", e)
    if (!!e) {
      // console.log("setting selected to", e)
      props.onSelect(e);
    } else {
      // console.log("setting selected to blank")
      props.onSelect(null);
    }
    
  }

  const select_styles = () => {
        return {
        control: (base) => {
            return {
                ...base,
                minHeight: 28,
                width:'75%',
                fontSize: '1.0em',
                paddingBottom: 0,
                paddingTop: 0,
                marginBottom: 0,
                marginTop: 0,

                borderColor: reactSelectBorderColor

            }
        },
        menuPortal: (base) => {
          return { ...base, zIndex: 9999 }
        },
        dropdownIndicator: (base) => ({
          ...base,
          paddingTop: 0,
          paddingBottom: 0,
          height: '1.0em',
        }),
        clearIndicator: (base) => ({
          ...base,
          paddingTop: 0,
          paddingBottom: 0,
          marginBottom: 0,
          marginTop: 0,
          height: '1.0em',
          fontSize: '1.0em',
        }),
        input: styles => {
            return {
              ...styles,
              height: '1.0em',
              fontSize: '0.8em',
        }},
        menu: (base) => ({
            ...base,
            fontSize: '0.9em',
        }),
        spacing: (base) => ({
            ...base.spacing,
            baseUnit: 1
        })

    }}

  return (
    <Select
        styles={select_styles()}
        // styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} 
        isClearable={true}
        menuPortalTarget={document.body}
        isSearchable={true}
        // name={f.name}
        options={props.statuses}
        // ref={refDeviceStatus}
        onChange={(e) => onSelect(e)}
        // defaultValue={props.defaultValue}
        value={props.value}
    />
  )
}

export default DeviceStatusDropdown
